import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Loader } from "@/components/portal/ui";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback({ portalKey, redirectTo }) {
  const { googleSession } = useAuth();
  const navigate = useNavigate();
  const processed = useRef(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const hash = window.location.hash || "";
    const sid = new URLSearchParams(hash.replace(/^#/, "")).get("session_id");
    if (!sid) {
      navigate(redirectTo, { replace: true });
      return;
    }
    (async () => {
      try {
        await googleSession(sid, portalKey || null, false);
        window.history.replaceState(null, "", window.location.pathname);
        navigate(redirectTo, { replace: true });
      } catch (e) {
        setError("Anmeldung fehlgeschlagen");
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (error)
    return (
      <div className="min-h-screen flex items-center justify-center" style={{ color: "var(--text)" }}>
        {error}
      </div>
    );
  return (
    <div className="min-h-screen flex items-center justify-center" style={{ background: "var(--bg)" }}>
      <Loader label="…" />
    </div>
  );
}
